/**
 * SEO 配置 - models 模块
 * 按语言拆分后的合并导出
 */

import en from './en'
import zh from './zh'
import ja from './ja'
import ko from './ko'
import es from './es'
import fr from './fr'
import de from './de'
import ru from './ru'
import pt from './pt'
import it from './it'
import ar from './ar'
import tw from './tw'
import pl from './pl'
import th from './th'
import da from './da'
import no from './no'
import nl from './nl'
import id from './id'
import tr from './tr'

export default {
    en,
    zh,
    ja,
    ko,
    es,
    fr,
    de,
    ru,
    pt,
    it,
    ar,
    tw,
    pl,
    th,
    da,
    no,
    nl,
    id,
    tr,
}
